const local = {

    en:{
    msg:"Personal Account",

    },

    ru:{
    msg:"Личный кабинет",

    },

    de:{
    msg:"Persönliches Kundenkonto",

    },

};

export default local;